import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { createGame, backupGame, deleteGame, updatePlayers } from '../../store/actions/gameActions'
import { updatePlayerChoices } from '../../store/actions/restaurantActions'
import { Redirect, useHistory } from 'react-router-dom'
import {setImage} from '../layout/SetImage'
import tagIcon from '../../icons/penguin.webp'


function openFinder(project, sortOptions){
    //console.log(Object.keys(this.props.sortOptions.openList));
    for(let key in Object.keys(sortOptions.openList)){
      // console.log(key);
      // console.log(this.props.sortOptions.openList[key]['id']);
        if (project.restaurantId === sortOptions.openList[key]['id'] && sortOptions.openList[key]['isOpen']){
          //console.log(this.props.sortOptions.openList[key]['opensAt']);
          return(true);
        }
      }

    return(false)

  }

function handleDelete(){
  document.getElementById("myModal").style.display = "block";  
}

function handleDeleteGame(props, game, dispatch, history, clearChoices){
  dispatch(backupGame(game));
  dispatch(deleteGame(props.match.params.gameId, ()=>{
    clearChoices();
    history.push("/game/createGame");
    M.updateTextFields();
  }));
}

function handleChoose(choice, setChoiceMade, setRedirecting){
  setRedirecting(true);
  setChoiceMade(choice);
}

function chooseRandoms(gameId, userId, dispatch, restaurants, randomThree){
  dispatch(updatePlayerChoices(false, gameId, false, userId, randomThree,
        ()=>{}
        ));
}

function GameInProgress(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const currentGames = useSelector((state)=>state.firestore.data.games);
  const restaurants = useSelector((state)=>state.firestore.data.restaurants);
  const [currentGame, setCurrentGame] = useState(false);
  const userId = useSelector((state)=>state.firebase.auth.uid);
  const user = useSelector((state)=>state.firestore.data.users[userId]);
  const sortOptions = useSelector((state)=>state.restaurant.sortOptions);
  const [numOfPlayers, setNumOfPlayers] = useState(2);
  const [numOfChoices, setNumOfChoices] = useState(3);
  const [gameName, setGameName] = useState(false);
  const [playerName, setPlayerName] = useState(false);
  const [currentPlayers, setCurrentPlayers] = useState(Array(numOfPlayers).fill(false));
  const [currentNames, setCurrentNames] = useState({test:'test'});
  const [randomChoice, setRandomChoice] = useState(false);
  const [fromFavorites, setFromFavorites] = useState(false);
  const [maxDistance, setMaxDistance] = useState(99);
  const settings = {
    numOfPlayers: numOfPlayers,
    numOfChoices: numOfChoices,
    gameName: gameName,
    currentPlayers: currentPlayers,
    currentNames: currentNames,
    randomChoice: randomChoice,
    fromFavorites: fromFavorites,
    maxDistance: maxDistance
  }
  const[playerChoices, setPlayerChoices] = useState(Array(numOfChoices).fill(false));
  const[players, setPlayers] = useState(false);
  const[choiceMade, setChoiceMade] = useState(false);
  const[redirecting, setRedirecting] = useState(false);
  const[randomChosen, setRandomChosen] = useState(false);
  const[randomThree, setRandomThree] = useState([]);


  useEffect(()=>{M.updateTextFields()}
  ,[])

  useEffect(()=>{
    if(choiceMade!==false){
      let choiceString = '/newChooseRestaurant/' + props.match.params.gameId + '/' + choiceMade;
      history.push(choiceString);
    }
  }
  ,[choiceMade])

  function clearChoices(){
    setNumOfPlayers(2);
    setNumOfChoices(3);
    setCurrentGame(false);
    setGameName(false);
    setPlayerName(false);
    setCurrentPlayers(Array(2).fill(false));
    setCurrentNames({test:'test'});
    setRandomChoice(false);
    setFromFavorites(false);
    setMaxDistance(99);
  }

  if (!userId) return <Redirect to='/signin' />
  // if(choiceMade !== false){
  //   return <Redirect to={'/chooseRestaurant/' + props.match.params.gameId + '/' + choiceMade} />
  // }

  if(currentGames && currentGames[props.match.params.gameId] && currentGame !== currentGames[props.match.params.gameId]){
    setCurrentGame(currentGames[props.match.params.gameId]);
  }
  else if (currentGames && !currentGames[props.match.params.gameId]){
    return <Redirect to={'/game/createGame'} />  
  }

  if(currentGames === null){
    return <Redirect to={'/game/createGame'} />   
  }

  // load game settings if there is a game
  if(currentGames && userId && currentGame){
    if(numOfPlayers!==currentGame.settings.numOfPlayers){
      setNumOfPlayers(currentGame.settings.numOfPlayers);  
    }
    if(numOfChoices!==currentGame.settings.numOfChoices){
      setNumOfChoices(currentGame.settings.numOfChoices);
    }
    if(gameName!==currentGame.settings.gameName){
      setGameName(currentGame.settings.gameName);
    }
    if(currentPlayers!==currentGame.settings.currentPlayers){
      setCurrentPlayers(currentGame.settings.currentPlayers);
    }
    if(playerChoices.length !== numOfChoices){
      setPlayerChoices(Array(numOfChoices).fill(false));    
    }
    if(currentNames!==currentGame.settings.currentNames){
      setCurrentNames(currentGame.settings.currentNames);
    }
    if(randomChoice!==currentGame.settings.randomChoice){
      setRandomChoice(currentGame.settings.randomChoice)
    }    
    if(fromFavorites!==currentGame.settings.fromFavorites){
      setFromFavorites(currentGame.settings.fromFavorites)
    }
    if(maxDistance!==currentGame.settings.maxDistance){
      setMaxDistance(currentGame.settings.maxDistance)
    }
  }


  // console.log('currentGame');
  // console.log(currentGame);

  if(currentGame && players !== currentGame.settings['currentPlayers']){
    setPlayers(currentGame.settings['currentPlayers']);
  }
  // console.log('players');
  // console.log(players);
  
  var choicesFull = !playerChoices.some(obj => !obj);
  // console.log('choicesFull');
  // console.log(choicesFull);

  // console.log('player Choices');
  // console.log(currentGame["playerChoices"])
  
  let filteredRestaurants = [];

  if(currentGame && currentGame.settings && currentGame.settings.maxDistance && currentGame.settings.randomChoice){
    for(let rest in Object.entries(restaurants)){
      if(user.distanceList[Object.entries(restaurants)[rest][0]]<currentGame.settings.maxDistance){
        if(openFinder(restaurants[Object.entries(restaurants)[rest][0]], sortOptions)){
          filteredRestaurants.push(Object.entries(restaurants)[rest]);  
        }
      } 
    }
    //console.log("fillty");
    //console.log(filteredRestaurants);
    if(filteredRestaurants.length < currentGame.settings.numOfChoices){
      filteredRestaurants = [...Object.entries(restaurants)];
    }
  }
  else{
    filteredRestaurants = [...Object.entries(restaurants)];
  }
    

  if(currentGame && currentGame.settings && currentGame.settings.randomChoice && randomThree.length < currentGame.settings.numOfChoices){
    let newThree = [...randomThree];
    let randomNumber = Math.floor(Math.random() * filteredRestaurants.length);
    if(!newThree.includes(filteredRestaurants[randomNumber][0])){
      newThree.push(filteredRestaurants[randomNumber][0]);
      setRandomThree(newThree);  
    }
  }
  //console.log('randomThree');
  //console.log(randomThree);


  if(currentGame && currentGame["playerChoices"]){
    let testAll = Object.entries(currentGame["playerChoices"]).map(obj => {
      return(!obj[1].some(itm => !itm))
    });
    if(!testAll.some(obj=>!obj)){
      //console.log("all full");
      return <Redirect to={'/tournament/' + props.match.params.gameId} />
    }
    else if(currentGame.settings.randomChoice){
      if(!randomChosen && randomThree.length === currentGame.settings.numOfChoices){
        setRandomChosen(true);
        chooseRandoms(props.match.params.gameId, userId, dispatch, filteredRestaurants, randomThree);  
      }
    }  
  }
  


  return (
    <>
      <div style={{display:"flex", flexFlow:"column"}}>
        <div id="myModal" className="modal2">
                <div className="modal-content2">
                  <span className="close2" onClick={()=>{closeFunction()}}>&times;</span>
                  <p>Are you sure you want to delete?</p>
                  { 
                  <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                    <button className="btn pink lighten-1" onClick={()=>{handleDeleteGame(props, currentGame, dispatch, history, clearChoices)}}>Delete</button>
                  </div>
                  }
              </div>
        </div>
        <h5 style={{textAlign:"center"}}>Choose your restaurants.</h5>
        { !redirecting && currentGame && currentGame['playerChoices'] && players && players.map(player=>{
          return(
            <div key={player}>
              <div style={{"display": "flex", "justifyContent": "center"}}>
                <p>{currentGame.settings['currentNames'][player]}</p>
              </div>
              <div style={{display:"flex", flexFlow:"row", "justifyContent": "center",  overflowX:"hidden", height:"80px"}}>
              {currentGame && currentGame["playerChoices"] && currentGame["playerChoices"][player].map((choice, index)=>{
                if(!choice){
                  return(
                      <div key={"choice"+index} className='tagIcon' style={{"display": "flex", "justifyContent": "center", "padding": "8px"}}>
                        <img alt="Tag Icon"  height="50" src={tagIcon} onClick={()=>{
                          if(player===userId && !currentGame.settings.randomChoice){
                            handleChoose(parseInt(index), setChoiceMade, setRedirecting)  
                          }
                        }}/>
                        <br/>
                      </div>
                    )
                }
                else{
                  return(
                      <div key={"choice"+index} className='tagIcon' style={{"display": "flex", "padding": "8px"}} onClick={()=>{
                          if(player===userId && !currentGame.settings.randomChoice){
                            handleChoose(parseInt(index), setChoiceMade, setRedirecting)
                          }
                        }}>
                        {setImage(restaurants[choice]['primaryTag'])}
                        <br/>
                      </div>
                    ) 
                }
              })}
              </div>
              
            </div>
            )
        })
        }

        { !redirecting && !choicesFull && currentGame && currentGame['playerChoices'] && !currentGame.settings.randomChoice && currentGame['playerChoices'][userId].map((choice, index)=>{
          if(!choice){
            return(
                    <div key={"choiceButton"+index} className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                      <button className="btn pink lighten-1" onClick={()=>{handleChoose(parseInt(index), setChoiceMade, setRedirecting)}}>{"Choose Restaurant "+ (parseInt(index)+1) }</button>
                    </div>
                  )
          }
        })
        }

        { !redirecting && currentGame && currentGame['settings'] && !currentGame['playerChoices'] &&
          <div>
            <p style={{textAlign:"center"}}>Waiting on...</p>
            <p style={{textAlign:"center"}}>{currentGame['settings']['currentNames'][currentGame['authorId']]}</p>
          </div>
        }

        { !redirecting && currentGame['authorId'] === userId &&
        <div>
          <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
            <button className="btn pink lighten-1" onClick={()=>{handleDelete()}}>Delete Game</button>
          </div>
        </div>
        }

        { redirecting && 
          <p style={{textAlign:"center"}}>Redirecting...</p>
        }
        
      </div>
    </>
  );
}

export default GameInProgress;